import { useCallback, useMemo } from "react";
import {
  createFeaturePreferences,
  FeaturePreferences,
  featurePreferenceStorageRecord,
} from "lib/storage/featurePreference";
import { useLocalStorage } from "./useLocalStorage";

export function useFeaturePreference() {
  const [storageData, setStorageData] = useLocalStorage("feature-preferences");

  const data = useMemo(() => {
    if (storageData == null) {
      return createFeaturePreferences(undefined);
    }

    try {
      const parsed = featurePreferenceStorageRecord(JSON.parse(storageData));
      return createFeaturePreferences(parsed);
    } catch {
      console.warn("failed to deserialize FeaturePreferences from storage");
      return createFeaturePreferences(undefined);
    }
  }, [storageData]);

  const set = useCallback(
    (data: FeaturePreferences) => {
      setStorageData(JSON.stringify(data));
      return data;
    },
    [setStorageData]
  );

  return useMemo(() => ({ data, set }), [data, set]);
}
